/******************************************************************************
Tree Inventory Reducer: Handles all interactions & state changes with the tree
inventory component.
Hawaiian Macadamia Nut Services
Alexander Self
03/27/20
*******************************************************************************/
import { SET_FORM_TYPE, PREPARE_TREE_INVENTORY, CREATE_INVENTORY_REQUEST,
  FETCH_INVENTORY, ISSUE_OR_RECEIVE_INVENTORY_REQUEST, APPROVE_INVENTORY_REQUEST,
  DOWNLOAD_INVENTORY, SET_INVENTORY_TO_EDIT, EDIT_ISSUE_OR_RECEIVE_INVENTORY_REQUEST,
  SET_INVENTORY_TO_DELETE, DELETE_INVENTORY_REQUEST } from '../actions/types';
import { dynamicReverseSort } from '../../utils';
let initState = {
  formType: 'issueOrReceiveInventory', // Default Value of the switch
  inventory: [], // Running master list of all inventory
  inventoryTransactions: [], // Running list of all inventory transactions
  approvers: [],
  view: {}, // Inventory viewed
  edit: {}, // Inventory to edit
  delete: {}, // Inventory to delete
  req: { // Inventory request
    inventoryMaster: {}, // The master inventory record that transactions are requested against
    approver: { eid: null }, // Approver of the request
    previousInventoryTransactions: [] // Any inventory transactions against a particular field(nursery location)
  }
};

export default function TreeInventoryReducer(state=initState, action) {
  switch (action.type) {
    case FETCH_INVENTORY:
      return { ...state,
        inventory: action.inventory,
        inventoryTransactions: action.inventoryTransactions.sort(dynamicReverseSort('isApproved')),
        approvers: action.approvers,
      };
    case SET_FORM_TYPE:
      return { ...state,
        formType: action.payload
      };
    case PREPARE_TREE_INVENTORY:
      return { ...state,
        req: { ...action.payload,
          inventoryMaster: state.inventory.find((i) => i.physicalLocation === action.payload.field) || {}
        }
      };
    case CREATE_INVENTORY_REQUEST:
      return { ...state,
        formType: initState.formType,
        inventory: state.inventory.concat(action.inventory),
        inventoryTransactions: state.inventoryTransactions.concat(action.inventoryTransaction).sort(dynamicReverseSort('isApproved'))
      };
    case ISSUE_OR_RECEIVE_INVENTORY_REQUEST:
      return { ...state,
        formType: initState.formType,
        inventoryTransactions: state.inventoryTransactions.concat(action.inventoryTransaction).sort(dynamicReverseSort('isApproved'))
      };
    case APPROVE_INVENTORY_REQUEST:
      return { ...state,
        inventory: state.inventory.filter((i) => i.inventoryId !== action.inventoryMaster.inventoryId).concat(action.inventoryMaster),
        inventoryTransactions: state.inventoryTransactions.filter((i) => i.id !== action.inventoryTransaction.id)
                                                          .concat(action.inventoryTransaction)
                                                          .sort(dynamicReverseSort('isApproved'))
      };
    case SET_INVENTORY_TO_EDIT:
      return { ...state,
        edit: action.payload
      };
    case DOWNLOAD_INVENTORY:
      return state;
    case EDIT_ISSUE_OR_RECEIVE_INVENTORY_REQUEST:
      console.log(action.inventoryMaster)
      return { ...state,
        formType: initState.formType,
        edit: initState.edit, 
        inventoryTransactions: state.inventoryTransactions.filter((i) => i.id !== state.edit.id)
                                                          .concat(action.payload)
                                                          .sort(dynamicReverseSort('isApproved')),
        inventory: state.inventory.filter((i) => i.id !== action.inventoryMaster.id)
                                                          .concat(action.inventoryMaster)
                                                          .sort(dynamicReverseSort('physicalLocation'))
      };
    case SET_INVENTORY_TO_DELETE:
      return { ...state,
        delete: action.payload
      };
    case DELETE_INVENTORY_REQUEST:
      return { ...state,
        inventoryTransactions: state.inventoryTransactions.filter((i) => i.id !== state.delete.id)
                                                          .sort(dynamicReverseSort('isApproved')),
        delete: initState.delete
      };                                                   
    default:
      return state;
  }
}






















/* END */



// WEBPACK FOOTER //
// ./src/cultivation/reducers/tree_inventory_reducer.js